export const CONSENT_MANAGER_WIZARD_TYPE = "consent-manager";
